<template>
	<Icon
		class="justify-centertext-gray-light flex animate-spin items-center"
		type="spinner"
	/>
</template>
<script lang="ts" setup>
	import Icon from '@hub-client/components/elements/Icon.vue';
</script>
